<template>
  <div class="intro" id="top" style="height: 100%;" >
    <section class="">
      <div class="hero-body " :class="widthMax < 1024 ? 'bg-spa':''">
        <div class="container media container media is-align-center">
          <figure class="media-left">
            <a class="link is-info" href="/batch/view">
              <img alt="Spa logo" class="is-hidden-mobile" src="@/assets/logo-spa-top.png">
              <img alt="Spa logo" style="width: 122px;" class="is-hidden-desktop" src="@/assets/logo-spa-mobile.svg">
            </a>
          </figure>
          <div class="media-content has-text-centered">
            <div class="content th">
              <h2 class="title is-2" :class="widthMax < 1024 ? 'has-text-white':''">{{title}}</h2>
              <h5 class="subtitle is-5" :class="widthMax < 1024 ? 'has-text-white':''">{{subtitle}}</h5>
            </div>
          </div>
          <div class="media-right" v-if="widthMax > 1024">
            <img alt="InteGreat logo" class="opacity-less" src="../assets/logo.png">
            <img alt="InteGreat logo" class="opacity-less" src="../assets/logo-spa-mobile.svg">
          </div>
        </div>
      </div>
    </section>
    <div class="box container">
      <step :id="stepId" v-if="steps && rule === 'admin'" :stepIndex="stepIndex"></step>

      <stepStartup :id="stepId" v-if="steps && rule === 'startup'" :stepIndex="stepIndex"></stepStartup>

      <stepStaff :id="stepId" v-if="steps && rule === 'staff'" :stepIndex="stepIndex"></stepStaff>
      
      <stepExclusiveBoard :id="stepId" v-if="steps && rule === 'exclusiveboard'" :stepIndex="stepIndex"></stepExclusiveBoard>

      <stepBoard :id="stepId" v-if="steps && rule === 'board'" :stepIndex="stepIndex"></stepBoard>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import StepsWizard from "bulma-extensions/bulma-steps/dist/js/bulma-steps.min";
import "bulma-extensions/bulma-steps/dist/js/bulma-steps.min";
import Step from "@/components/StepSpa.vue";
import stepStartup from "@/components/StepSpaStartup.vue";
import stepStaff from "@/components/StepSpaStaff.vue";
import stepExclusiveBoard from "@/components/StepSpaExclusiveBoard.vue";
import stepBoard from "@/components/StepSpaBoard.vue";
import { mapGetters } from "vuex";

export default {
  name: "DefaultTemplate",
  components: {
    Step,
    stepStartup,
    stepStaff,
    stepExclusiveBoard,
    stepBoard
  },
  props: {
    title: String,
    subtitle: String,
    stepId: String,
    steps: Boolean,
  },
  data() {
    return {
      currentStep: "User information",
      rule: this.$route.params.rule,
      stepIndex: null,
      widthMax: window.innerWidth,
    };
  },
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    },
    token() {
      return this.$store.state.token;
    }
  },
  methods: {
    fetchInitData() {
      if (this.stepId) {
        this.stepIndex = new StepsWizard(document.getElementById(this.stepId));
      }
      // this.stepIndex.activate_step(1);
    }
  },
  mounted() {
    this.fetchInitData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "/node_modules/bulma-extensions/bulma-steps/dist/css/bulma-steps.min.css";

.box .steps .step-item .step-marker{
  border: 0.1em solid #0a0a0a1a;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.logoBox {
  width: 2rem;
}
.hero {
  padding-top: 1.5rem;
}
.hero-body {
  padding: 30px 1.5rem !important;
}
.intro{
  background: #fff;
  height: 100%;
}
.intro .title, .intro .subtitle{
  color: #000;
}

@media screen and (min-width:768px) and (max-width:1023px) {
  .subtitle.is-5{
    font-size: 16px;
  }
  .box{
    border-radius: 0;
    -webkit-box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1), 0 0 0 0px rgba(10, 10, 10, 0.1);
    box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1), 0 0 0 0px rgba(10, 10, 10, 0.1);
  }
}

@media screen and (min-width: 100px) and (max-width: 767px) {

  .title.is-2{
    font-size: 26px;
  }
  .subtitle.is-5{
    font-size: 12px;
  }
  .box{
    border-radius: 0;
    -webkit-box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1), 0 0 0 0px rgba(10, 10, 10, 0.1);
    box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1), 0 0 0 0px rgba(10, 10, 10, 0.1);
  }
  .logoBox {
    width: 5rem;
  }
  .hero-body{
    padding: 30px 0.5rem !important;
  }
}
</style>
